var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0C5.37248 0 -0.000488281 5.37245 -0.000488281 12C-0.000488281 18.6275 5.37248 24 11.9998 24C18.6276 24 24 18.6275 24 12C24 5.37245 18.6276 0 11.9998 0ZM11.9998 23.4C5.70349 23.4 0.600047 18.2961 0.600047 12C0.600047 5.70398 5.70349 0.599849 11.9998 0.599849C18.296 0.599849 23.3999 5.70396 23.3999 12C23.3999 18.2961 18.296 23.4 11.9998 23.4Z",
    fill: "url(#paint0_linear_6873_225876)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4866 12C23.4866 18.3431 18.3436 23.4859 12.0005 23.4859C5.6573 23.4859 0.514832 18.3431 0.514832 12C0.514832 5.65662 5.6573 0.51416 12.0005 0.51416C18.3436 0.51416 23.4866 5.65662 23.4866 12Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4008 12.0002C23.4008 18.2963 18.2969 23.4002 12.0006 23.4002C5.70434 23.4002 0.600891 18.2963 0.600891 12.0002C0.600891 5.70423 5.70434 0.600098 12.0006 0.600098C18.2969 0.600098 23.4008 5.70423 23.4008 12.0002Z",
    fill: "url(#paint1_radial_6873_225876)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6435 11.9998C19.6435 16.2207 16.2217 19.6424 12.0006 19.6424C7.77952 19.6424 4.35767 16.2208 4.35767 11.9998C4.35767 7.77872 7.77952 4.35693 12.0006 4.35693C16.2217 4.35693 19.6435 7.77874 19.6435 11.9998Z",
    fill: "url(#paint2_linear_6873_225876)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3061 4.15033L13.1 2.0461V4.15033H13.703V1.13672H12.7968L11.9726 3.29443H11.9804L11.1562 1.13672H10.25V4.15033H10.853V2.0461L11.6469 4.15033H12.3061Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5813 5.50193L19.5511 7.00409L21.1693 6.20823L21.6082 6.73456L19.0614 8.01334L18.5468 7.39031L19.534 5.90184L19.5282 5.8945L17.8861 6.59734L17.3656 5.9785L19.0828 3.70459L19.5218 4.23121L18.4466 5.67919L20.1107 4.93698L20.5813 5.50193Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66314 4.92634C6.42044 4.69074 6.04594 4.61971 5.69388 4.83796C5.76128 4.66363 5.73392 4.48618 5.69828 4.38776C5.54643 4.11166 5.4932 4.07673 5.36921 3.97199C4.96443 3.63286 4.53862 3.92244 4.23444 4.28496L2.76379 6.03763L5.07575 7.97726L6.62651 6.12944C6.98096 5.70712 7.03568 5.28841 6.66314 4.92634ZM3.6724 5.77156L4.55576 4.71884C4.65828 4.59701 4.88973 4.60189 5.03816 4.72692C5.20171 4.86412 5.20218 5.05843 5.09235 5.18954L4.21881 6.23009L3.6724 5.77156ZM6.10944 5.9466L5.18854 7.04404L4.61192 6.5594L5.53966 5.45348C5.64463 5.32845 5.87853 5.29208 6.03623 5.42438C6.21392 5.57382 6.23148 5.80111 6.10944 5.9466Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 4.03412L13.1069 1.92994V4.03412H13.71V1.02051H12.8037L11.9795 3.17815H11.9873L11.1631 1.02051H10.2568V4.03412H10.8599V1.92994L11.6538 4.03412H12.313Z",
    fill: "url(#paint3_radial_6873_225876)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5877 5.29976L19.5579 6.80196L21.176 6.00584L21.6145 6.53244L19.0681 7.81121L18.5535 7.18795L19.5408 5.69967L19.535 5.69212L17.8924 6.39524L17.3724 5.77609L19.0897 3.50244L19.5286 4.02885L18.4535 5.47681L20.117 4.73488L20.5877 5.29976Z",
    fill: "url(#paint4_radial_6873_225876)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55464 4.86686C6.31244 4.63127 5.93744 4.56019 5.58593 4.77825C5.65279 4.6039 5.62547 4.42642 5.58986 4.3285C5.43798 4.05192 5.38525 4.01747 5.26022 3.91252C4.85546 3.57317 4.43017 3.86292 4.12646 4.22577L2.65527 5.97816L4.96728 7.91781L6.51802 6.06971C6.87204 5.64736 6.92718 5.22894 6.55464 4.86686ZM3.564 5.71204L4.44727 4.65958C4.54936 4.53753 4.78076 4.54241 4.92968 4.66714C5.09326 4.8046 5.09376 4.99914 4.98338 5.12976L4.11038 6.17052L3.564 5.71204ZM6.00146 5.88707L5.08057 6.98449L4.50293 6.49985L5.43118 5.3937C5.53614 5.26895 5.76953 5.23256 5.92726 5.36491C6.10594 5.51454 6.12353 5.74135 6.00146 5.88707Z",
    fill: "url(#paint5_radial_6873_225876)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61188 12.0001C4.61188 7.9194 7.91995 4.61133 12.0004 4.61133C16.0814 4.61133 19.389 7.9194 19.389 12.0001C19.389 16.0806 16.0814 19.3886 12.0004 19.3886C7.91992 19.3886 4.61188 16.0806 4.61188 12.0001Z",
    fill: "url(#paint6_radial_6873_225876)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8241 12.0001C4.8241 8.03684 8.03694 4.82373 12.0003 4.82373C15.9636 4.82373 19.1768 8.03681 19.1768 12.0001C19.1768 15.9635 15.9636 19.1766 12.0003 19.1766C8.03696 19.1766 4.8241 15.9635 4.8241 12.0001Z",
    fill: "url(#paint7_radial_6873_225876)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81329 12.0004H12.0007V4.81299C8.03099 4.81299 4.81329 8.03071 4.81329 12.0004Z",
    fill: "url(#paint8_radial_6873_225876)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 12V19.1875C15.9699 19.1875 19.1877 15.9691 19.1877 12H12.0003Z",
    fill: "url(#paint9_radial_6873_225876)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2475 11.8724H12.128V4.75293H11.8731V11.8724H4.75366V12.1273H11.8731V19.247H12.128V12.1273H19.2475V11.8724Z",
    fill: "url(#paint10_radial_6873_225876)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1274 4.95481C15.9189 5.02224 18.9784 8.08147 19.0462 11.8726H19.1731C19.1053 8.01116 15.9892 4.89455 12.1274 4.82715L12.1274 4.95481Z",
    fill: "url(#paint11_linear_6873_225876)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94172 11.8715C5.00907 8.07513 8.07297 5.01149 11.8693 4.94385V4.81641C8.00223 4.88402 4.88215 8.00479 4.81427 11.8714H4.94172V11.8715Z",
    fill: "#C2D7E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8727 19.0457C8.08133 18.9783 5.02183 15.9188 4.95443 12.1274H4.82703C4.89488 15.9891 8.01103 19.1059 11.8728 19.1732L11.8727 19.0457Z",
    fill: "url(#paint12_linear_6873_225876)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0462 12.1274C18.9783 15.9188 15.9188 18.9783 12.1274 19.0457V19.1732C15.9891 19.1059 19.1057 15.9892 19.1731 12.1274H19.0462Z",
    fill: "#12404F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.737 4.81641V11.7325H4.82111V11.869H11.737H11.8732V11.7325V4.81641H11.737Z",
    fill: "url(#paint13_linear_6873_225876)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7249 19.1063V12.2734H4.87787V12.1387H11.7249H11.8596V12.2734V19.1063H11.7249Z",
    fill: "url(#paint14_linear_6873_225876)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2734 19.1063V12.2734H19.1063V12.1387H12.2734H12.1392V12.2734V19.1063H12.2734Z",
    fill: "url(#paint15_linear_6873_225876)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2734 4.87744V11.7103H19.1063V11.8448H12.2734H12.1392V11.7103V4.87744H12.2734Z",
    fill: "url(#paint16_linear_6873_225876)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6873_225876",
    x1: -1.75715,
    y1: -1.29384,
    x2: 23.7048,
    y2: 23.3108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0984,
    stopColor: "#D6EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    stopColor: "#BFD0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4879,
    stopColor: "#98A5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#646B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.149214 0.793907) scale(17.0491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3064,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6873_225876",
    x1: 20.7624,
    y1: 20.4665,
    x2: 4.54576,
    y2: 4.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855,
    stopColor: "#D6EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2327,
    stopColor: "#BED0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    stopColor: "#96A4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6516,
    stopColor: "#5F686D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9075,
    stopColor: "#1A1D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.21131 -0.942565) scale(40.9664 40.9664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3102,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4505,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5567,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7238,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7944,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8593,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9199,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9746,
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.2132 -0.942475) scale(40.9699 40.9699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3102,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4505,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5567,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7238,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7944,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8593,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9199,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9746,
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.21599 -0.954592) scale(41.0013 41.0013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3102,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4505,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5567,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7238,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7944,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8593,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9199,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9746,
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.12571 4.73693) scale(11.0499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1045,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5884,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9335,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.14779 6.22315) scale(16.0697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3435,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4814,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5824,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6654,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7373,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8602,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9494,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9566,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.42996 0.131885) scale(28.4597)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1957,
    stopColor: "#E0EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2406,
    stopColor: "#B2D9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2872,
    stopColor: "#8BC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#6BB5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3844,
    stopColor: "#52A9D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4359,
    stopColor: "#41A0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#369BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#3396C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6553,
    stopColor: "#328EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7045,
    stopColor: "#3180A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    stopColor: "#2F6D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8027,
    stopColor: "#2D5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8512,
    stopColor: "#2A373D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#292929"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.42958 0.131334) scale(28.4591 28.4591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1957,
    stopColor: "#E0EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2406,
    stopColor: "#B2D9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2872,
    stopColor: "#8BC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#6BB5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3844,
    stopColor: "#52A9D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4359,
    stopColor: "#41A0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#369BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#3396C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6553,
    stopColor: "#328EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7045,
    stopColor: "#3180A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    stopColor: "#2F6D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8027,
    stopColor: "#2D5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8512,
    stopColor: "#2A373D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#292929"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_6873_225876",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.27682 4.87614) scale(10.8381 10.8381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1045,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5884,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9335,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6873_225876",
    x1: 10.5789,
    y1: 2.17025,
    x2: 21.1481,
    y2: 12.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#EBEFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2475,
    stopColor: "#DCE0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4028,
    stopColor: "#C4C7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5701,
    stopColor: "#A2A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#76777C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#414243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6873_225876",
    x1: 2.00023,
    y1: 10.7932,
    x2: 12.5697,
    y2: 21.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#EBEFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2475,
    stopColor: "#DCE0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4028,
    stopColor: "#C4C7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5701,
    stopColor: "#A2A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#76777C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#414243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6873_225876",
    x1: 7.11398,
    y1: 7.15106,
    x2: 12.5947,
    y2: 12.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1337,
    stopColor: "#BACFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3425,
    stopColor: "#A4BACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#8098AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#4E697F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A566D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6873_225876",
    x1: 4.36873,
    y1: 8.44892,
    x2: 14.8318,
    y2: 18.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0973,
    stopColor: "#E8EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2568,
    stopColor: "#D1D4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4587,
    stopColor: "#ABAEB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6951,
    stopColor: "#78797D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9578,
    stopColor: "#363637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6873_225876",
    x1: 12.0804,
    y1: 12.1994,
    x2: 15.7506,
    y2: 15.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    stopColor: "#D4DAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#C7CFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4114,
    stopColor: "#B0BCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#90A1B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#677F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8849,
    stopColor: "#355674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9719,
    stopColor: "#173D5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6873_225876",
    x1: 8.32596,
    y1: 4.61144,
    x2: 18.7777,
    y2: 14.7113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#EBEFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2475,
    stopColor: "#DCE0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4028,
    stopColor: "#C4C7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5701,
    stopColor: "#A2A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#76777C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#414243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPartner);
export default __webpack_public_path__ + "static/media/logo-partner.642ef435418bfb3975cf0c42bdd2bdfe.svg";
export { ForwardRef as ReactComponent };